<template>
  <div class="personalisation-list-content-root-wrapper">
    <ErrorMessage
      v-if="isPersonalisationListInvalid"
      slot="devices-list"
      :header="$t('common.error.api')"
      :content="$t('common.error.api_content')"
    />
    <TableListLoader
      v-else-if="isPersonalisationListLoading"
      :numberOfElementsToDisplay="20"
      :listStructure="personalisationRowStructure"
    />
    <PersonalisationListTable
      v-else
      :personalisationState="personalisationState"
    />
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import ErrorMessage from '@/components/common/ErrorMessage/ErrorMessage.vue';
import { IPersonalisationListState } from '@/store/modules/personalisation/types';
import TableListLoader from '@/components/common/TableListLoader/TableListLoader.vue';
import PersonalisationListTable from './components/PersonalisationListTable/PersonalisationListTable.vue';

import './styles/personalisation-content.scss';

@Component({
  components: {
    PersonalisationListTable,
    TableListLoader,
    ErrorMessage
  }
})
export default class PersonalisationContent extends Vue {
  @Prop()
  private personalisationState!: IPersonalisationListState;

  private personalisationRowStructure = {
    data: 8,
    withCheckbox: false,
    withExpansion: false
  };

  private get isPersonalisationListLoading(): boolean {
    return this.personalisationState.loading.personalisationList;
  }

  private get isPersonalisationListInvalid() {
    return this.personalisationState.error.personalisationList;
  }
}
</script>
